import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

// pkg/dist-src/index.js
import { Octokit as Octokit3 } from "@octokit/core"; // pkg/dist-src/errors.js

var generateMessage = function generateMessage(path, cursorValue) {
  return "The cursor at \"".concat(path.join(","), "\" did not change its value \"").concat(cursorValue, "\" after a page transition. Please make sure your that your query is set up correctly.");
};

var MissingCursorChange = /*#__PURE__*/function (_Error) {
  _inherits(MissingCursorChange, _Error);

  var _super = _createSuper(MissingCursorChange);

  function MissingCursorChange(pageInfo, cursorValue) {
    var _this;

    _classCallCheck(this, MissingCursorChange);

    _this = _super.call(this, generateMessage(pageInfo.pathInQuery, cursorValue));
    _this.pageInfo = pageInfo;
    _this.cursorValue = cursorValue;
    _this.name = "MissingCursorChangeError";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    }

    return _this;
  }

  return _createClass(MissingCursorChange);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var MissingPageInfo = /*#__PURE__*/function (_Error2) {
  _inherits(MissingPageInfo, _Error2);

  var _super2 = _createSuper(MissingPageInfo);

  function MissingPageInfo(response) {
    var _this2;

    _classCallCheck(this, MissingPageInfo);

    _this2 = _super2.call(this, "No pageInfo property found in response. Please make sure to specify the pageInfo in your query. Response-Data: ".concat(JSON.stringify(response, null, 2)));
    _this2.response = response;
    _this2.name = "MissingPageInfo";

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this2), _this2.constructor);
    }

    return _this2;
  }

  return _createClass(MissingPageInfo);
}( /*#__PURE__*/_wrapNativeSuper(Error)); // pkg/dist-src/object-helpers.js


var isObject = function isObject(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
};

function findPaginatedResourcePath(responseData) {
  var paginatedResourcePath = deepFindPathToProperty(responseData, "pageInfo");

  if (paginatedResourcePath.length === 0) {
    throw new MissingPageInfo(responseData);
  }

  return paginatedResourcePath;
}

var deepFindPathToProperty = function deepFindPathToProperty(object, searchProp) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var currentPath = [].concat(_toConsumableArray(path), [key]);
    var currentValue = object[key];

    if (currentValue.hasOwnProperty(searchProp)) {
      return currentPath;
    }

    if (isObject(currentValue)) {
      var result = deepFindPathToProperty(currentValue, searchProp, currentPath);

      if (result.length > 0) {
        return result;
      }
    }
  }

  return [];
};

var get = function get(object, path) {
  return path.reduce(function (current, nextProperty) {
    return current[nextProperty];
  }, object);
};

var set = function set(object, path, mutator) {
  var lastProperty = path[path.length - 1];

  var parentPath = _toConsumableArray(path).slice(0, -1);

  var parent = get(object, parentPath);

  if (typeof mutator === "function") {
    parent[lastProperty] = mutator(parent[lastProperty]);
  } else {
    parent[lastProperty] = mutator;
  }
}; // pkg/dist-src/extract-page-info.js


var extractPageInfos = function extractPageInfos(responseData) {
  var pageInfoPath = findPaginatedResourcePath(responseData);
  return {
    pathInQuery: pageInfoPath,
    pageInfo: get(responseData, [].concat(_toConsumableArray(pageInfoPath), ["pageInfo"]))
  };
}; // pkg/dist-src/iterator.js


import { Octokit } from "@octokit/core"; // pkg/dist-src/page-info.js

var isForwardSearch = function isForwardSearch(givenPageInfo) {
  return givenPageInfo.hasOwnProperty("hasNextPage");
};

var getCursorFrom = function getCursorFrom(pageInfo) {
  return isForwardSearch(pageInfo) ? pageInfo.endCursor : pageInfo.startCursor;
};

var hasAnotherPage = function hasAnotherPage(pageInfo) {
  return isForwardSearch(pageInfo) ? pageInfo.hasNextPage : pageInfo.hasPreviousPage;
}; // pkg/dist-src/iterator.js


var createIterator = function createIterator(octokit) {
  return function (query) {
    var initialParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var nextPageExists = true;

    var parameters = _objectSpread({}, initialParameters);

    return _defineProperty({}, Symbol.asyncIterator, function () {
      return {
        next: function next() {
          return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var response, pageInfoContext, nextCursorValue;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (nextPageExists) {
                      _context.next = 2;
                      break;
                    }

                    return _context.abrupt("return", {
                      done: true,
                      value: {}
                    });

                  case 2:
                    _context.next = 4;
                    return octokit.graphql(query, parameters);

                  case 4:
                    response = _context.sent;
                    pageInfoContext = extractPageInfos(response);
                    nextCursorValue = getCursorFrom(pageInfoContext.pageInfo);
                    nextPageExists = hasAnotherPage(pageInfoContext.pageInfo);

                    if (!(nextPageExists && nextCursorValue === parameters.cursor)) {
                      _context.next = 10;
                      break;
                    }

                    throw new MissingCursorChange(pageInfoContext, nextCursorValue);

                  case 10:
                    parameters = _objectSpread(_objectSpread({}, parameters), {}, {
                      cursor: nextCursorValue
                    });
                    return _context.abrupt("return", {
                      done: false,
                      value: response
                    });

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        }
      };
    });
  };
}; // pkg/dist-src/paginate.js


import { Octokit as Octokit2 } from "@octokit/core"; // pkg/dist-src/merge-responses.js

var mergeResponses = function mergeResponses(response1, response2) {
  if (Object.keys(response1).length === 0) {
    return Object.assign(response1, response2);
  }

  var path = findPaginatedResourcePath(response1);
  var nodesPath = [].concat(_toConsumableArray(path), ["nodes"]);
  var newNodes = get(response2, nodesPath);

  if (newNodes) {
    set(response1, nodesPath, function (values) {
      return [].concat(_toConsumableArray(values), _toConsumableArray(newNodes));
    });
  }

  var edgesPath = [].concat(_toConsumableArray(path), ["edges"]);
  var newEdges = get(response2, edgesPath);

  if (newEdges) {
    set(response1, edgesPath, function (values) {
      return [].concat(_toConsumableArray(values), _toConsumableArray(newEdges));
    });
  }

  var pageInfoPath = [].concat(_toConsumableArray(path), ["pageInfo"]);
  set(response1, pageInfoPath, get(response2, pageInfoPath));
  return response1;
}; // pkg/dist-src/paginate.js


var createPaginate = function createPaginate(octokit) {
  var iterator = createIterator(octokit);
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query) {
      var initialParameters,
          mergedResponse,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          response,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              initialParameters = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              mergedResponse = {};
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context2.prev = 4;
              _iterator = _asyncIterator(iterator(query, initialParameters));

            case 6:
              _context2.next = 8;
              return _iterator.next();

            case 8:
              if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                _context2.next = 14;
                break;
              }

              response = _step.value;
              mergedResponse = mergeResponses(mergedResponse, response);

            case 11:
              _iteratorAbruptCompletion = false;
              _context2.next = 6;
              break;

            case 14:
              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 20:
              _context2.prev = 20;
              _context2.prev = 21;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context2.next = 25;
                break;
              }

              _context2.next = 25;
              return _iterator.return();

            case 25:
              _context2.prev = 25;

              if (!_didIteratorError) {
                _context2.next = 28;
                break;
              }

              throw _iteratorError;

            case 28:
              return _context2.finish(25);

            case 29:
              return _context2.finish(20);

            case 30:
              return _context2.abrupt("return", mergedResponse);

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 16, 20, 30], [21,, 25, 29]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}; // pkg/dist-src/index.js


function paginateGraphql(octokit) {
  octokit.graphql;
  return {
    graphql: Object.assign(octokit.graphql, {
      paginate: Object.assign(createPaginate(octokit), {
        iterator: createIterator(octokit)
      })
    })
  };
}

export { paginateGraphql };